import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ApiClient from "../../api-client";
import { apiUrl, PORT } from "../../environment";

toast.configure();
/**
 * @description method use to make payment for new subscription
 * @param {*} data card ddetails encripted
 * @param {*} callback response back to call
 */
export const payment = (data, callback) => {
    return (dispatch, getState) => {
        const { user: { token } } = getState();
        ApiClient.post(`${apiUrl}${PORT}/subscription`, data, token, dispatch).then((response) => {
            if (response.errors) {
                return callback(false);
            } else if (response) {
                dispatch({ type: "UPDATE_SUBSCRIPTIONS", data: response });
                return callback(response);
            } else {
                return callback(false);
            }
        });
    };
};

/**
 * @description method call to get all plans 
 * @param {\} data accepting json object limit,page,order etc..
 * @param {*} callback response to back 
 */
export const getPlans = (data, callback) => {
    return (dispatch, getState) => {
        const { user: { token } } = getState();
        dispatch({ type: "ISLOADING", data: true });
        ApiClient.get(`${apiUrl}${PORT}/plan`, data, token, dispatch).then((response) => {
            dispatch({ type: "ISLOADING", data: false });
            if (response.errors) {
                callback(false);
            } else if (response) {
                callback(response);
            } else {
                callback(false);
            }
        });
    };
};

/**
 * @description method call to get subscription details
 * @param {\} data accepting json object limit,page,order etc..
 * @param {*} callback response to back 
 */
export const get = (param, callback) => {
    return (dispatch, getState) => {
        const { user: { token } } = getState();
        dispatch({ type: "ISLOADING", data: true });
        ApiClient.get(`${apiUrl}${PORT}/subscription`, param, token, dispatch).then((response) => {
            dispatch({ type: "ISLOADING", data: false });
            if (response.errors) {
                callback(false);
            } else if (response) {
                callback(response);
            } else {
                callback(false);
            }
        });
    };
};

/**
 * @description method call to get subscription details
 * @param {\} data accepting json object limit,page,order etc..
 * @param {*} callback response to back 
 */
export const getpdf = (id, callback) => {
    return (dispatch, getState) => {
        const { user: { token } } = getState();
        dispatch({ type: "ISLOADING", data: true });
        ApiClient.get(`${apiUrl}${PORT}/transaction/invoice/${id}`, {}, token, dispatch).then((response) => {
            dispatch({ type: "ISLOADING", data: false });
            if (response.errors) {
                callback(false);
            } else if (response) {
                callback(response);
            } else {
                callback(false);
            }
        });
    };
};
/**
 * @description method call to upgrade plans 
 * @param {*} params accepting object
 */
export const update = (data, id, callback) => {
    return (dispatch, getState) => {
        const { user: { token }, } = getState();
        ApiClient.put(`${apiUrl}${PORT}/subscription/${id}`, data, token, dispatch).then(
            (response) => {
                if (response.errors) {
                    callback(false);
                } else if (response) {
                    dispatch({ type: "UPDATE_SUBSCRIPTIONS", data: response });
                    callback(response);
                } else {
                    callback(false);
                }
            }
        );
    };
};

/**
 * @description method call to upgrade plans 
 * @param {*} data accepting object
 */
export const cancel = (callback) => {
    return (dispatch, getState) => {
        const { user: { token }, } = getState();
        ApiClient.post(`${apiUrl}${PORT}/subscription/cancel`, {}, token, dispatch).then(
            (response) => {
                if (response.errors) {
                    callback(false);
                } else if (response) {
                    dispatch({ type: "UPDATE_SUBSCRIPTIONS", data: response });
                    callback(response);
                } else {
                    callback(false);
                }
            }
        );
    };
};